/**
 * The inert twin of the composer's insert separator: same rule, same dot, no
 * gesture attached — it opens a read-only itinerary.
 *
 * The dot is 24px and centred on the rule, so it eats 12px of the gutter on
 * each side: the padding has to clear that before it leaves any air between the
 * separator and the card underneath.
 */
export default function KoobSeparatorLine() {
  return (
    <div className="relative group py-7">
      <div className="w-full h-1 bg-gray-200 transition rounded-full">
        <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-gray-200 transition rounded-full flex justify-center items-center"></div>
      </div>
    </div>
  );
}
